// extracted by mini-css-extract-plugin
export const cookiesContainer = "cookiesWarning-module--cookiesContainer--bvyRT";
export const cookiesText = "cookiesWarning-module--cookiesText--3delu";